<script>
	import { AppContext, AppData } from './Context.svelte.js';
	import { DataTooltip } from '@vpap_svelte/charts';
	import { MediaQuery } from 'svelte/reactivity';
	import Controls from './Controls.svelte';
	import Row from './Row.svelte';
	import { innerWidth } from 'svelte/reactivity/window';

	/** @type {{ dataUrl?: string }} */
	let { dataUrl } = $props();

	let ctx = AppContext.set(new AppData({ url: dataUrl }));
	let isTouch = new MediaQuery('(hover: none) and (pointer: coarse)');

	$effect(() => {
		if (isTouch.current) {
			ctx.isTouchDevice = true;
		}
	});
</script>

<Controls />
<div>
	{#each ctx.activeData as entry (entry.legislator)}
		<Row {entry} />
	{/each}
</div>

<DataTooltip
	bind:visible={ctx.tooltip.visible}
	x={ctx.tooltip.x > innerWidth.current * 0.6 ? ctx.tooltip.x - 325 : ctx.tooltip.x}
	y={ctx.tooltip.y}
	position={ctx.isTouchDevice ? 'fixed-bottom' : 'fixed'}
	style={ctx.isTouchDevice ? { 'pointer-events': 'all', width: '100%' } : { width: '325px' }}
>
	{#if ctx.tooltip.data}
		{@const d = ctx.tooltip.data}
		<div class="tip-content">
			<div class="tip-name">{d.legislator} ({d.party.charAt(0)})</div>
			<div><span class="type">Bill: </span> {d.bill}</div>
			<div><span class="type">Description: </span> {d.bill_description}</div>
			<div><span class="type">Majority position: </span> {d.majority_position.split(' ')[0]}</div>
			<div><span class="type">Legislator position: </span> {d.legislator_position}</div>
			{#if ctx.isTouchDevice}
				<div class="tip-read-more">
					<a href={d.bill_url} target="_blank" rel="noreferrer">Read more details on the bill</a>
				</div>
			{:else}
				<div class="tip-desktop-hint">Click on the bill icon to read more</div>
			{/if}
		</div>
	{/if}
</DataTooltip>

<style>
	.tip-content {
		padding: 0.75rem;
		font-size: 0.9rem;
		line-height: 1.5;
	}

	.tip-name {
		font-weight: bold;
		font-size: 1rem;
		margin-bottom: 0.4rem;
		color: #42585c;
	}

	.type {
		font-weight: bold;
	}

	.tip-read-more {
		margin-top: 0.5rem;
	}

	.tip-read-more a {
		color: #3989cb;
	}

	.tip-desktop-hint {
		margin-top: 0.5rem;
		font-style: italic;
		color: #888;
		font-size: 0.8rem;
	}
</style>
